import { render, staticRenderFns } from "./YouAndMeTextIndex.vue?vue&type=template&id=c3957294&scoped=true&"
import script from "./YouAndMeTextIndex.vue?vue&type=script&lang=js&"
export * from "./YouAndMeTextIndex.vue?vue&type=script&lang=js&"
import style0 from "./YouAndMeTextIndex.vue?vue&type=style&index=0&id=c3957294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3957294",
  null
  
)

export default component.exports